import React, { FC } from 'react';
import { Star } from '../../../../../components/Icons/Star';
import { FlexGrid, FlexGridColumn } from '../../../../../components/FlexGrid';
import { jobModuleCodes } from '../../../../../data/translations/jobModuleCodes';
import { yellow } from '../../../../../components/Color';
import { useTranslationAPI } from '../../../../translations';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { Badge } from '../../../../../components/Badge';
import { Typography } from '../../../../../components/Typography';
import { MovingGradient } from '../../../../../components/MovingGradient';

export const PublicJobDetailTitle: FC<React.PropsWithChildren<{ fontSize: 28 | 16 }>> = ({ fontSize }) => {
	const { translate } = useTranslationAPI();
	const {
		data: { isTop, title, isExpired },
		isLoading,
	} = usePublicJobDetailDataQuery();
	const hasLastColumn = isTop || isExpired;

	return (
		<FlexGrid
			gap='tiny'
			center
		>
			{isTop && (
				<FlexGridColumn
					noGrow
					noShrink
				>
					<Star
						fill={yellow[7]}
						width={fontSize}
						height={fontSize}
					/>
				</FlexGridColumn>
			)}
			<FlexGridColumn
				grow
				wrappedText
			>
				{!isLoading && (
					<Typography
						fontSize={fontSize}
						bold
					>
						{title}
					</Typography>
				)}

				{isLoading && (
					<MovingGradient
						borderRadius='6px'
						height='14px'
						width='50%'
					/>
				)}
			</FlexGridColumn>
			{hasLastColumn && (
				<FlexGridColumn
					noGrow
					noShrink
				>
					{isTop && <Badge yellow>{translate(jobModuleCodes.topJob)}</Badge>}
					{isExpired && <Badge gray>{translate(jobModuleCodes.expiredJob)}</Badge>}
				</FlexGridColumn>
			)}
		</FlexGrid>
	);
};
